var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7998 6.08711C12.7998 6.52711 13.1598 6.88711 13.5998 6.88711H15.1998C15.6398 6.88711 15.9998 6.52711 15.9998 6.08711C15.9998 5.64711 15.6398 5.28711 15.1998 5.28711H13.5998C13.1598 5.28711 12.7998 5.64711 12.7998 6.08711Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6718 9.94307C11.4078 10.2951 11.4798 10.7831 11.8318 11.0391C12.2558 11.3511 12.7038 11.6871 13.1278 12.0071C13.4798 12.2711 13.9758 12.1991 14.2318 11.8471C14.2318 11.8391 14.2398 11.8391 14.2398 11.8311C14.5038 11.4791 14.4318 10.9831 14.0798 10.7271C13.6558 10.4071 13.2078 10.0711 12.7918 9.75907C12.4398 9.49507 11.9438 9.57507 11.6798 9.92707C11.6798 9.93507 11.6718 9.94307 11.6718 9.94307Z",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2475 0.335145C14.2475 0.327145 14.2395 0.327145 14.2395 0.319145C13.9755 -0.0328547 13.4795 -0.104855 13.1355 0.159145C12.7115 0.479145 12.2555 0.815145 11.8395 1.13515C11.4875 1.39915 11.4235 1.89515 11.6875 2.23915C11.6875 2.24715 11.6955 2.24715 11.6955 2.25515C11.9595 2.60715 12.4475 2.67915 12.7995 2.41515C13.2235 2.10315 13.6715 1.75915 14.0955 1.43915C14.4395 1.18315 14.5035 0.687145 14.2475 0.335145Z",
    fill: "#898989"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.68711H1.6C0.72 3.68711 0 4.40711 0 5.28711V6.88711C0 7.76711 0.72 8.48711 1.6 8.48711H2.4V10.8871C2.4 11.3271 2.76 11.6871 3.2 11.6871C3.64 11.6871 4 11.3271 4 10.8871V8.48711H4.8L8.8 10.8871V1.28711L4.8 3.68711Z",
    fill: "#898989"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7996 6.08698C10.7996 5.02298 10.3356 4.06298 9.59961 3.40698V8.75898C10.3356 8.11098 10.7996 7.15098 10.7996 6.08698Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/Newsletter.d1ca0f37894c0832b14bd67b5f26babb.svg";
export { ForwardRef as ReactComponent };